import dayjs from "dayjs"

export const isFriday = (date: string | Date) => dayjs(date).day() === 5

/**
 * Convierte una fecha sin hora ("YYYY-MM-DD", como la que entrega DateInput) a un Date anclado al mediodía UTC.
 * `new Date("YYYY-MM-DD")` cae en medianoche UTC, que en America/Lima (UTC-5) ya es las 19:00 del día anterior —
 * el backend valida el día de la semana en esa timezone, así que un viernes elegido en el calendario terminaba
 * evaluándose como jueves. Anclar a las 12:00 UTC (07:00 Lima) mantiene el mismo día calendario en Lima.
 */
export const toLimaSafeDate = (date: string) => new Date(`${date}T12:00:00.000Z`)
